<template>
  <div class="page page--seed">
    <Seed :id="$route.params.seedId" />
  </div>
</template>

<script>
// @ is an alias to /src
import Seed from '@/components/Seed.vue'

export default {
  name: 'SeedView',
  components: {
    Seed
  }
}
</script>
